<div class="d-flex align-items-start g-g">
  <form
    [formGroup]="modulationOrderOptionsForm"
    (ngSubmit)="addModulationOrderOption()"
    class="d-flex align-items-center g-g w-50"
  >
    <input
      type="text"
      formControlName="modulationOrder"
      placeholder="e.g. QPSK"
      class="form-control flex-fill"
    />
    <button
      type="submit"
      [disabled]="modulationOrderOptionsForm.invalid"
      class="btn btn-success text-nowrap"
    >
      <i class="fa-solid fa-circle-plus"></i>
      <i class="fa-solid fa-caret-right"></i>
    </button>
  </form>

  <ul
    class="flex-fill d-flex flex-column g-g modulation-order-subsection align-self-stretch"
  >
    <!-- Default -->
    @for (
      modulationOrder of defaultModulationOrderOptions;
      track modulationOrder;
      let i = $index
    ) {
      <li
        class="d-flex align-items-center g-g justify-content-between modulation-order-option default"
      >
        <div class="modulation-order-type">
          <span class="modulation-order-config-property-value">{{
            modulationOrder
          }}</span>
        </div>
        <span>default</span>
      </li>
    }
    <!-- Custom -->
    @for (
      modulationOrder of editableModulationOrderOptions;
      track modulationOrder;
      let i = $index
    ) {
      <li
        class="d-flex align-items-center g-g justify-content-between modulation-order-option"
      >
        <div class="modulation-order-type">
          <span class="modulation-order-config-property-value">{{
            modulationOrder
          }}</span>
        </div>
        <button (click)="removeModulationOrderOption(i)" class="remove-button">
          <i class="fa-solid fa-trash"></i>
        </button>
      </li>
    }
  </ul>
</div>
